import * as runtime from '../runtime';
import type {
  DeviceCreate,
  DeviceUpdate,
  HTTPValidationError,
} from '../models/index';
import {
    DeviceCreateFromJSON,
    DeviceCreateToJSON,
    DeviceUpdateFromJSON,
    DeviceUpdateToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
} from '../models/index';

export interface ApiAddDeviceV1ConfPostRequest {
    xToken: string;
    deviceCreate: DeviceCreate;
}

export interface ApiDeleteDeviceV1ConfDeviceIdDeleteRequest {
    deviceId: string;
    xToken: string;
}

export interface ApiGetConfListV1ConfGetRequest {
    xToken: string;
    page?: number | null;
    pageSize?: number | null;
}

export interface ApiPatchDeviceV1ConfDeviceIdPatchRequest {
    deviceId: string;
    xToken: string;
    deviceUpdate: DeviceUpdate;
}

export interface ApiUpdateDeviceV1ConfDeviceIdPutRequest {
    deviceId: string;
    xToken: string;
    deviceCreate: DeviceCreate;
}

/**
 * 
 */
export class ManagementApi extends runtime.BaseAPI {

    /**
     * Permet d\'ajouter un équipement dans la base de données.
     * Api Add Device
     */
    async apiAddDeviceV1ConfPostRaw(requestParameters: ApiAddDeviceV1ConfPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['xToken'] == null) {
            throw new runtime.RequiredError(
                'xToken',
                'Required parameter "xToken" was null or undefined when calling apiAddDeviceV1ConfPost().'
            );
        }

        if (requestParameters['deviceCreate'] == null) {
            throw new runtime.RequiredError(
                'deviceCreate',
                'Required parameter "deviceCreate" was null or undefined when calling apiAddDeviceV1ConfPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xToken'] != null) {
            headerParameters['x-token'] = String(requestParameters['xToken']);
        }


        let urlPath = `/v1/conf`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DeviceCreateToJSON(requestParameters['deviceCreate']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Permet d\'ajouter un équipement dans la base de données.
     * Api Add Device
     */
    async apiAddDeviceV1ConfPost(requestParameters: ApiAddDeviceV1ConfPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.apiAddDeviceV1ConfPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * suppression d\'un device
     * Api Delete Device
     */
    async apiDeleteDeviceV1ConfDeviceIdDeleteRaw(requestParameters: ApiDeleteDeviceV1ConfDeviceIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['deviceId'] == null) {
            throw new runtime.RequiredError(
                'deviceId',
                'Required parameter "deviceId" was null or undefined when calling apiDeleteDeviceV1ConfDeviceIdDelete().'
            );
        }

        if (requestParameters['xToken'] == null) {
            throw new runtime.RequiredError(
                'xToken',
                'Required parameter "xToken" was null or undefined when calling apiDeleteDeviceV1ConfDeviceIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xToken'] != null) {
            headerParameters['x-token'] = String(requestParameters['xToken']);
        }


        let urlPath = `/v1/conf/{device_id}`;
        urlPath = urlPath.replace(`{${"device_id"}}`, encodeURIComponent(String(requestParameters['deviceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * suppression d\'un device
     * Api Delete Device
     */
    async apiDeleteDeviceV1ConfDeviceIdDelete(requestParameters: ApiDeleteDeviceV1ConfDeviceIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.apiDeleteDeviceV1ConfDeviceIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Récupère la liste des devices dans la BDD.  Supports optional pagination via query parameters. Returns simple array by default, paginated response when both page and page_size provided.
     * Api Get Conf List
     */
    async apiGetConfListV1ConfGetRaw(requestParameters: ApiGetConfListV1ConfGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['xToken'] == null) {
            throw new runtime.RequiredError(
                'xToken',
                'Required parameter "xToken" was null or undefined when calling apiGetConfListV1ConfGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xToken'] != null) {
            headerParameters['x-token'] = String(requestParameters['xToken']);
        }


        let urlPath = `/v1/conf`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Récupère la liste des devices dans la BDD.  Supports optional pagination via query parameters. Returns simple array by default, paginated response when both page and page_size provided.
     * Api Get Conf List
     */
    async apiGetConfListV1ConfGet(requestParameters: ApiGetConfListV1ConfGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.apiGetConfListV1ConfGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * modification d\'un device
     * Api Patch Device
     */
    async apiPatchDeviceV1ConfDeviceIdPatchRaw(requestParameters: ApiPatchDeviceV1ConfDeviceIdPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['deviceId'] == null) {
            throw new runtime.RequiredError(
                'deviceId',
                'Required parameter "deviceId" was null or undefined when calling apiPatchDeviceV1ConfDeviceIdPatch().'
            );
        }

        if (requestParameters['xToken'] == null) {
            throw new runtime.RequiredError(
                'xToken',
                'Required parameter "xToken" was null or undefined when calling apiPatchDeviceV1ConfDeviceIdPatch().'
            );
        }

        if (requestParameters['deviceUpdate'] == null) {
            throw new runtime.RequiredError(
                'deviceUpdate',
                'Required parameter "deviceUpdate" was null or undefined when calling apiPatchDeviceV1ConfDeviceIdPatch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xToken'] != null) {
            headerParameters['x-token'] = String(requestParameters['xToken']);
        }


        let urlPath = `/v1/conf/{device_id}`;
        urlPath = urlPath.replace(`{${"device_id"}}`, encodeURIComponent(String(requestParameters['deviceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: DeviceUpdateToJSON(requestParameters['deviceUpdate']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * modification d\'un device
     * Api Patch Device
     */
    async apiPatchDeviceV1ConfDeviceIdPatch(requestParameters: ApiPatchDeviceV1ConfDeviceIdPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.apiPatchDeviceV1ConfDeviceIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * modification d\'un device
     * Api Update Device
     */
    async apiUpdateDeviceV1ConfDeviceIdPutRaw(requestParameters: ApiUpdateDeviceV1ConfDeviceIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['deviceId'] == null) {
            throw new runtime.RequiredError(
                'deviceId',
                'Required parameter "deviceId" was null or undefined when calling apiUpdateDeviceV1ConfDeviceIdPut().'
            );
        }

        if (requestParameters['xToken'] == null) {
            throw new runtime.RequiredError(
                'xToken',
                'Required parameter "xToken" was null or undefined when calling apiUpdateDeviceV1ConfDeviceIdPut().'
            );
        }

        if (requestParameters['deviceCreate'] == null) {
            throw new runtime.RequiredError(
                'deviceCreate',
                'Required parameter "deviceCreate" was null or undefined when calling apiUpdateDeviceV1ConfDeviceIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xToken'] != null) {
            headerParameters['x-token'] = String(requestParameters['xToken']);
        }


        let urlPath = `/v1/conf/{device_id}`;
        urlPath = urlPath.replace(`{${"device_id"}}`, encodeURIComponent(String(requestParameters['deviceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DeviceCreateToJSON(requestParameters['deviceCreate']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * modification d\'un device
     * Api Update Device
     */
    async apiUpdateDeviceV1ConfDeviceIdPut(requestParameters: ApiUpdateDeviceV1ConfDeviceIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.apiUpdateDeviceV1ConfDeviceIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
